import { Box, Flex } from '@skin-seoul/design-system';
import ProductCardSkeleton from '@/components/products/ProductCard/ProductCard.Skeleton';
const YearEndCampaignProductSwiperSkeleton = () => {
  return <Box position="relative" width="100%" data-sentry-element="Box" data-sentry-component="YearEndCampaignProductSwiperSkeleton" data-sentry-source-file="YearEndCampaignProductSwiper.skeleton.tsx">
      <Flex width="100%" gap={6} data-sentry-element="Flex" data-sentry-source-file="YearEndCampaignProductSwiper.skeleton.tsx">
        {[...Array(5)].map((_, index) => <Box key={index} flexBasis={{
        base: '50%',
        tablet: '33.333%',
        desktop: '20%'
      }} display={{
        base: index < 2 ? 'block' : 'none',
        tablet: index < 3 ? 'block' : 'none',
        desktop: 'block'
      }}>
            <ProductCardSkeleton orientation="vertical" />
          </Box>)}
      </Flex>
    </Box>;
};
export default YearEndCampaignProductSwiperSkeleton;